/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
export default {
    baseStyle: {
        container: {display: 'flex'},
        label: {
            width: 'full'
        },
        control: {
            backgroundColor: 'white',
            width: '18px',
            height: '18px',
            borderWidth: '1px',
            borderColor: 'black',
            _checked: {
                backgroundColor: 'white',
                borderColor: 'black',
                _hover: {
                    backgroundColor: 'white',
                    borderColor: 'black',
                    opacity: 0.9
                },
                _before: {
                    background: 'black',
                    width: '12px',
                    height: '12px',
                }
            },
            _indeterminate: {}
        }
    },
    sizes: {
        md: {
            container: {alignItems: 'flex-start'},
            control: {marginTop: '0.25em'},
            label: {marginLeft: 3}
        }
    }
}
